import React from "react";
import PropTypes from "prop-types";
import { Container, Grid } from "@material-ui/core";
import { Bar } from "react-chartjs-2";
import { useChartData } from "./hooks/useChartData";
import { useChartControls } from "./hooks/useChartControls";
import { FormSelect } from "./components/FormSelect";
import { ChartDateRangeControls } from "./components/ChartDateRangeControls";
import { LoadingSpinner } from "./components/LoadingSpinner";
import { CHART_TYPE_OPTIONS, PERIOD_OPTIONS } from "./constants/chartOptions";

function SummaryChartsComponent({
  users,
  sessions,
  videos,
  subscriptions,
  recurringSubscriptions,
  canceledSubscriptions,
  staffAccounts,
  deviceLimitExceptionList,
}) {
  const chartControls = useChartControls();
  const startDate = String(chartControls.selectionRange.startDate.valueOf());
  const endDate = String(chartControls.selectionRange.endDate.valueOf());

  const { data, options, isLoading, isError, error } = useChartData(
    chartControls.statType,
    startDate,
    endDate,
    chartControls.statPeriod,
    chartControls.selectionRange,
    {
      subscriptions,
      recurringSubscriptions,
      canceledSubscriptions,
      users,
      sessions,
      videos,
      staffAccounts,
      deviceLimitExceptionList,
    }
  );

  const handleRangeChange = (ranges) => {
    chartControls.handleRangeChange(ranges);
  };

  return (
    <>
      <Container component="main" style={{ padding: "20px 0" }}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <FormSelect
              label="Statistics"
              labelId="stat-type-select"
              value={chartControls.statType}
              onChange={chartControls.handleStatType}
              options={CHART_TYPE_OPTIONS}
            />
          </Grid>
          <Grid item xs={6}>
            <FormSelect
              label="Period"
              labelId="stat-period-select"
              value={chartControls.statPeriod}
              onChange={chartControls.handleStatPeriod}
              options={PERIOD_OPTIONS}
            />
          </Grid>
          <ChartDateRangeControls
            selectionRange={chartControls.selectionRange}
            onRangeChange={handleRangeChange}
            openDialog={chartControls.openRangeDialog}
            onOpenDialog={chartControls.setOpenRangeDialog}
            onReset={chartControls.handleReset}
          />
          <Grid item xs={12}>
            {!isLoading ? (
              <Bar options={options} data={data} />
            ) : (
              <LoadingSpinner show={isLoading} />
            )}
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

SummaryChartsComponent.propTypes = {
  users: PropTypes.array,
  sessions: PropTypes.array,
  videos: PropTypes.array,
  subscriptions: PropTypes.array,
  recurringSubscriptions: PropTypes.array,
  canceledSubscriptions: PropTypes.array,
  staffAccounts: PropTypes.array,
  deviceLimitExceptionList: PropTypes.array,
};

export const SummaryCharts = SummaryChartsComponent;
